import { StoreType } from '@tock/shared/utils/connect';

export const navigationSelector = (state: StoreType) => state.navigation;
